<template>
  <!-- <div class="container boxWithBorder"> -->
  <div class="my-5">
    <h1 class="is-size-4">When shopping for travel</h1>
    <b-field
      class="mt-5"
      label="How do you want to display a result that violates a rule?"
    ></b-field>
    <b-field>
      <b-radio
        :value="visibilityObj.visibility"
        native-value="show"
        @input="emitVisibility"
      >
        Show the result and allow it to be booked
      </b-radio></b-field
    >
    <b-field>
      <b-radio
        :value="visibilityObj.visibility"
        native-value="unselectable"
        @input="emitVisibility"
        >Show the result but do not allow it to be booked
      </b-radio>
    </b-field>
    <b-field>
      <b-radio
        :value="visibilityObj.visibility"
        native-value="hide"
        @input="emitVisibility"
        >Hide the result
      </b-radio>
    </b-field>
  </div>
</template>
<script>
export default {
  name: "Visibility",
  props: {
    visibility: String,
  },
  components: {},
  data() {
    return {
      visibilityObj: {
        visibility: this.visibility,
      },
    };
  },
  methods: {
    emitVisibility(val) {
      this.visibilityObj.visibility = val;
      this.$emit("emitData", this.visibilityObj);
    },
  },
  mounted() {
    this.$emit("emitData", this.visibilityObj);
  },
  watch: {
    visibility: {
      handler(newVal, prevVal) {
        this.visibilityObj.visibility = newVal;
      },
      deep: false,
    },
  },
};
</script>
